import { Editor } from '@tiptap/react';

export interface ToolbarAction {
  name: string;
  icon: string;
  label: string;
  command: (editor: Editor) => void;
}

export const toolbarActions: ToolbarAction[] = [
  {
    name: 'emoji',
    icon: 'expression',
    label: '表情',
    command: () => {},
  },
  {
    name: 'image',
    icon: 'photoBar',
    label: '图片',
    command: () => {},
  },
  {
    name: 'video',
    icon: 'videoBar',
    label: '视频',
    command: () => {},
  },
];
